import { configureStore } from "@reduxjs/toolkit";
// import documentReducer from "../slices/documentSlice"

import sidebarReducer from "../slices/SideBarSlice";
export const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
